<ngx-spinner type="ball-clip-rotate"></ngx-spinner>
<ng-container *ngIf="!(initialized && isDxsales && (page === 'forgot-password' || page === 'password-reset-send'))">
  <div id="background"></div>
</ng-container>
<header class="header" *ngIf="initialized && !isDxsales">
  <img [src]="logoImagePath" width="233px"/>
</header>
<ng-container *ngIf="initialized && isDxsales">
  <ng-container *ngIf="page === 'login'">
    <app-collabo-portal-dxsales-login></app-collabo-portal-dxsales-login>
  </ng-container>
  <ng-container *ngIf="page === 'forgot-password'">
    <app-collabo-portal-dxsales-forgot-password></app-collabo-portal-dxsales-forgot-password>
  </ng-container>
  <!-- 送信しましたページ -->
  <ng-container *ngIf="page === 'password-reset-send'">
    <app-collabo-portal-dxsales-change-password-sent></app-collabo-portal-dxsales-change-password-sent>
  </ng-container>
</ng-container>
<ng-container *ngIf="initialized && isKanri">
  <app-collabo-portal-kanri-login></app-collabo-portal-kanri-login>
</ng-container>
<ng-container *ngIf="initialized && !isDxsales && !isKanri">
  <div *ngIf="page === 'login'">
    <div class="container">
      <div
        data-app="true"
        class="v-application v-application--is-ltr theme--light"
      >
        <div class="v-application--wrap">
          <div class="inner">
            <div class="mb-10" style="display: flex; justify-content: center">
              <h1 class="h3">ログイン</h1>
            </div>

            <div
              class="v-input v-input--dense theme--light v-text-field v-text-field--filled v-text-field--is-booted v-text-field--enclosed"
            >
              <div class="v-input__control">
                <label for="email" class="bold">メールアドレス</label>
                <div class="v-input__slot">
                  <input
                    style="height: 100%"
                    (focus)="focus(inputState.email)"
                    (blur)="blur(inputState.email)"
                    [(ngModel)]="email"
                    id="email"
                    type="email"
                  />
                </div>
                <div class="v-text-field__details">
                  <!-- エラー時 class="v-messages ..." に error--text を追加 ↓ -->
                  <div class="v-messages theme--light error--text">
                    <div
                      *ngIf="errorMessages.login.email"
                      class="v-messages__wrapper"
                    >
                      {{ errorMessages.login.email }}

                      <!-- 注釈及びエラーテキストが入ります。 -->
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- focus時 class="v-input ..." に v-input--is-focused、primary--text を追加 ↓ -->
            <!-- エラー時 class="v-input ..." に v-input--has-state、error--text を追加 ↓ -->
            <div
              class="v-input v-input--dense theme--light v-text-field v-text-field--filled v-text-field--is-booted v-text-field--enclosed"
            >
              <div class="v-input__control">
                <label for="password" class="bold">パスワード</label>
                <app-collabo-portal-password-input
                  [(ngModel)]="password"
                  name="confirm"
                  placeholder="パスワード（再入力）"
                ></app-collabo-portal-password-input>
                <div class="v-text-field__details">
                  <!-- エラー時 class="v-messages ..." に error--text を追加 ↓ -->
                  <div class="v-messages theme--light error--text">
                    <div
                      *ngIf="errorMessages.login.password"
                      class="v-messages__wrapper"
                    >
                      {{ errorMessages.login.password }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <label class="agreement d-flex align-start mb-6">
              <!-- TODO margin-topじゃない自動レイアウト -->
              <div
                style="margin-top: 5px"
                class="v-input v-input--is-focused theme--light v-input--selection-controls v-input--checkbox"
                (click)="checkIsEmailSave()"
              >
                <div class="v-input__control">
                  <div style="height: 32px; align-items: center">
                    <div 
                      class="v-input--selection-controls__input primary--text"
                    >
                      <i
                        aria-hidden="true"
                        [class]="isEmailSaveCheckedStyle.i"
                      ></i
                      ><input
                        [(ngModel)]="isSaveEmail"
                        aria-checked="true"
                        id="input-32"
                        role="checkbox"
                        type="checkbox"
                        value=""
                      />
                      <div [class]="isEmailSaveCheckedStyle.div"></div>
                    </div>
                  </div>
                </div>
              </div>
              <span class="text-gray600">メールアドレスを保存する</span></label
            >

            <div class="text-center mb-6">
              <button
                (click)="login()"
                type="button"
                class="v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default primary full-width"
                medium=""
              >
                <span class="v-btn__content"> ログインする </span>
              </button>
            </div>

            <div class="mb-6">
              <div
                style="
                  display: flex;
                  justify-content: center;
                  align-items: baseline;
                "
              >
                <a
                  (click)="navigate('forgot-password')"
                  class="text-link v-text-caption"
                >
                  パスワードを忘れた方はこちら
                </a>
              </div>

              <div class="mb-6"></div>

              <!-- 最初は新規登録させない -->
              <div
                *ngIf="false"
                class="mb-4"
                style="justify-content: center; display: flex"
              >
                <button
                  (click)="navigate('register')"
                  class="btn-lighten-5 v-btn theme--dark"
                >
                  <p class="v-text bold">新規登録</p>
                </button>
              </div>

              <div
                style="
                  display: flex;
                  justify-content: center;
                  align-items: baseline;
                "
              >
                <a
                  (click)="navigate('register-resend')"
                  class="text-link v-text-caption"
                >
                  認証メールが届かない方はこちら
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="page === 'register'">
    <div class="container">
      <div class="auto-layout">
        <app-collabo-portal-oem-register-message
          [clientId]="clientId"
          *ngIf="isOem"
        ></app-collabo-portal-oem-register-message>
        <p *ngIf="!isOem" class="v-text">
          Doctors Stationへようこそ。<br />まずはあなたのアカウントを作りましょう
        </p>
      </div>
      <div
        data-app="true"
        class="v-application v-application--is-ltr theme--light"
      >
        <div class="v-application--wrap">
          <div class="inner">
            <div class="name-area">
              <!-- focus時 class="v-input ..." に v-input--is-focused、primary--text を追加 ↓ -->
              <!-- エラー時 class="v-input ..." に v-input--has-state、error--text を追加 ↓ -->
              <div
                class="v-input v-input--dense theme--light v-text-field v-text-field--filled v-text-field--is-booted v-text-field--enclosed"
              >
                <div class="v-input__control">
                  <div
                    class="v-input__slot"
                    [ngClass]="
                      errorMessages.signup.familyName ? ['custom-error'] : []
                    "
                  >
                    <div class="v-text-field__slot v-text-body-1">
                      <!-- focus時 class="v-label ..." に v-label--active、primary--text を追加 ↓ -->
                      <label for="lastName" [class]="familyNameLabelClass"
                        >姓</label
                      >
                      <input
                        (focus)="focus(inputState.lastName)"
                        (blur)="blur(inputState.lastName)"
                        [(ngModel)]="lastName"
                        id="lastName"
                        type="text"
                      />
                    </div>
                  </div>
                  <div class="v-text-field__details">
                    <!-- エラー時 class="v-messages ..." に error--text を追加 ↓ -->
                    <div class="v-messages theme--light error--text">
                      <div
                        *ngIf="errorMessages.signup.familyName"
                        class="v-messages__wrapper"
                      >
                        {{ errorMessages.signup.familyName }}
                        <!-- 注釈及びエラーテキストが入ります。 -->
                        <!-- 半角英数字と記号を3種類以上含めた、8文字以上のパスワードを入力してください。 -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- focus時 class="v-input ..." に v-input--is-focused、primary--text を追加 ↓ -->
              <!-- エラー時 class="v-input ..." に v-input--has-state、error--text を追加 ↓ -->
              <div
                class="v-input v-input--dense theme--light v-text-field v-text-field--filled v-text-field--is-booted v-text-field--enclosed"
              >
                <div class="v-input__control">
                  <div
                    class="v-input__slot"
                    [ngClass]="
                      errorMessages.signup.givenName ? ['custom-error'] : []
                    "
                  >
                    <div class="v-text-field__slot v-text-body-1">
                      <!-- focus時 class="v-label ..." に v-label--active、primary--text を追加 ↓ -->
                      <label for="firstName" [class]="givennameLabelClass"
                        >名</label
                      >
                      <input
                        (focus)="focus(inputState.firstName)"
                        (blur)="blur(inputState.firstName)"
                        [(ngModel)]="firstName"
                        id="firstName"
                        type="text"
                      />
                    </div>
                  </div>
                  <div class="v-text-field__details">
                    <!-- エラー時 class="v-messages ..." に error--text を追加 ↓ -->

                    <div class="v-messages theme--light error--text">
                      <div
                        *ngIf="errorMessages.signup.givenName"
                        class="v-messages__wrapper"
                      >
                        {{ errorMessages.signup.givenName }}
                        <!-- 注釈及びエラーテキストが入ります。 -->
                        <!-- 半角英数字と記号を3種類以上含めた、8文字以上のパスワードを入力してください。 -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="isOem" style="margin-top: -20px; margin-bottom: 20px">
              <p class="v-text-caption">陽性者本人の姓名を入力してください</p>
            </div>

            <div
              class="v-input v-input--dense theme--light v-text-field v-text-field--filled v-text-field--is-booted v-text-field--enclosed"
            >
              <div class="v-input__control">
                <div
                  class="v-input__slot"
                  [ngClass]="errorMessages.signup.email ? ['custom-error'] : []"
                >
                  <div class="v-text-field__slot">
                    <!-- focus時 class="v-label ..." に v-label--active、primary--text を追加 ↓ -->
                    <label for="email" [ngClass]="inputLabelClass" class="bold"
                      >メールアドレス</label
                    >
                    <input
                      (focus)="focus(inputState.email)"
                      (blur)="blur(inputState.email)"
                      [(ngModel)]="email"
                      id="email"
                      type="email"
                    />
                  </div>
                </div>
                <div class="v-text-field__details">
                  <!-- エラー時 class="v-messages ..." に error--text を追加 ↓ -->
                  <div class="v-messages theme--light error--text">
                    <div
                      *ngIf="errorMessages.signup.email"
                      class="v-messages__wrapper"
                    >
                      {{ errorMessages.signup.email }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- focus時 class="v-input ..." に v-input--is-focused、primary--text を追加 ↓ -->
            <!-- エラー時 class="v-input ..." に v-input--has-state、error--text を追加 ↓ -->
            <div
              class="v-input v-input--dense theme--light v-text-field v-text-field--filled v-text-field--is-booted v-text-field--enclosed"
            >
              <div class="v-input__control">
                <div
                  class="v-input__slot"
                  [ngClass]="
                    errorMessages.signup.password ? ['custom-error'] : []
                  "
                >
                  <div class="v-text-field__slot">
                    <!-- focus時 class="v-label ..." に v-label--active、primary--text を追加 ↓ -->
                    <label
                      for="password"
                      [ngClass]="passwordLabelClass"
                      class="bold"
                      >パスワード</label
                    >
                    <input
                      (focus)="focus(inputState.password)"
                      (blur)="blur(inputState.password)"
                      [(ngModel)]="password"
                      id="password"
                      [type]="passwordToggle.password ? 'text' : 'password'"
                    />
                  </div>
                  <div class="v-input__append-inner">
                    <div class="v-input__icon v-input__icon--append">
                      <app-mdi-eye
                        [show]="passwordToggle.password"
                        (click)="
                          passwordToggle.password = !passwordToggle.password
                        "
                      ></app-mdi-eye>
                    </div>
                  </div>
                </div>
                <div class="v-text-field__details">
                  <!-- エラー時 class="v-messages ..." に error--text を追加 ↓ -->
                  <div class="v-messages theme--light error--text">
                    <div
                      *ngIf="errorMessages.signup.password"
                      class="v-messages__wrapper"
                    >
                      {{ errorMessages.signup.password }}
                    </div>
                    <div *ngIf="!errorMessages.signup.password">
                      <p class="v-text-caption">
                        半角英数字と記号を3種類以上含めた、8文字以上のパスワードを入力してください
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- focus時 class="v-input ..." に v-input--is-focused、primary--text を追加 ↓ -->
            <!-- エラー時 class="v-input ..." に v-input--has-state、error--text を追加 ↓ -->
            <div
              class="mb-6 v-input v-input--dense theme--light v-text-field v-text-field--filled v-text-field--is-booted v-text-field--enclosed"
            >
              <div class="v-input__control">
                <div
                  class="v-input__slot"
                  [ngClass]="
                    errorMessages.signup.confirmPassword ? ['custom-error'] : []
                  "
                >
                  <div class="v-text-field__slot">
                    <!-- focus時 class="v-label ..." に v-label--active、primary--text を追加 ↓ -->
                    <label
                      for="confirmationPassword"
                      [ngClass]="confirmPasswordLabelClass"
                      class="bold"
                      >パスワード（確認）</label
                    >
                    <input
                      (focus)="focus(inputState.confirmPassword)"
                      (blur)="blur(inputState.confirmPassword)"
                      id="confirmationPassword"
                      [type]="passwordToggle.confirm ? 'text' : 'password'"
                      [(ngModel)]="confirmPassword"
                    />
                  </div>
                  <div class="v-input__append-inner">
                    <div class="v-input__icon v-input__icon--append">
                      <app-mdi-eye
                        [show]="passwordToggle.confirm"
                        (click)="
                          passwordToggle.confirm = !passwordToggle.confirm
                        "
                      ></app-mdi-eye>
                    </div>
                  </div>
                </div>
                <div class="v-text-field__details">
                  <!-- エラー時 class="v-messages ..." に error--text を追加 ↓ -->
                  <div class="v-messages theme--light error--text">
                    <div
                      *ngIf="errorMessages.signup.confirmPassword"
                      class="v-messages__wrapper"
                    >
                      {{ errorMessages.signup.confirmPassword }}
                    </div>
                    <div *ngIf="!errorMessages.signup.confirmPassword">
                      <p class="v-text-caption">
                        パスワードを確認するために再入力してください
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <label class="agreement d-flex align-start mb-6"
              ><div
                class="v-input v-input--is-focused theme--light v-input--selection-controls v-input--checkbox mb-8"
                (click)="check()"
              >
                <div class="v-input__control">
                  <div>
                    <div
                      class="v-input--selection-controls__input primary--text"
                    >
                      <i
                        aria-hidden="true"
                        [class]="checkedStyle.i"
                        class="bold"
                      ></i
                      ><input
                        aria-checked="true"
                        id="input-32"
                        role="checkbox"
                        type="checkbox"
                        value=""
                      />
                      <div [class]="checkedStyle.div"></div>
                    </div>
                  </div>
                  <div class="v-messages theme--light error--text">
                    <div
                      *ngIf="errorMessages.signup.terms"
                      class="v-messages__wrapper"
                    >
                      {{ errorMessages.signup.terms }}
                    </div>
                  </div>
                </div>
              </div>
              <span
                ><a
                  [href]="termsUrl"
                  target="_blank"
                  class="text-link primary--text"
                  >利用規約</a
                >および<a
                  [href]="privacyUrl"
                  target="_blank"
                  class="text-link primary--text"
                  >プライバシーポリシー</a
                >に同意します。</span
              ></label
            >

            <div class="text-center mb-6">
              <button
                type="button"
                class="primary-button full-width v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default primary"
                medium=""
                (click)="register()"
              >
                <span class="v-btn__content text-button-medium"> 登録 </span>
              </button>
            </div>

            <div
              style="
                display: flex;
                justify-content: center;
                align-items: baseline;
              "
            >
              <div class="text-center mb-6 v-text-caption">
                認証メールが届かない方
              </div>
              <a
                (click)="navigate('register-resend')"
                class="text-link v-text-caption"
              >
                メール再送信
              </a>
            </div>

            <div class="divider mb-3"></div>

            <div
              style="
                display: flex;
                justify-content: space-between;
                align-items: baseline;
              "
            >
              <div class="text-center mb-6 v-text-caption">
                アカウントをお持ちの方
              </div>
              <button
                (click)="navigate('login')"
                class="btn-lighten-5 v-btn theme--dark"
              >
                <p class="v-text bold">ログイン</p>
              </button>
              <!-- <a (click)="navigate('login')" class="text-link"> ログイン </a> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="page === 'forgot-password'">
    <div class="container isBackgoround">
      <main>
        <div
          class="container_min v-application v-application--is-ltr theme--light"
        >
          <form style="width: 100%; margin-top: 100px">
            <!-- <div class="text-center mb-10">
              <p style="text-align: left" class="v-text">
                下記に登録したメールアドレスを入力してください。パスワード再設定のご案内をメールでお送りします。
              </p>
            </div> -->
            <h1 class="mb-10 h3">パスワード再設定</h1>
            <div
              class="v-input v-input--is-label-active v-input--is-dirty v-input--dense theme--light v-text-field v-text-field--filled v-text-field--is-booted v-text-field--enclosed"
            >
              <div class="v-input__control">
                <label for="input-13" class="bold">メールアドレス</label>
                <div class="v-input__slot">
                  <input
                    (focus)="focus(inputState.email)"
                    (blur)="blur(inputState.email)"
                    id="input-13"
                    name="input-13"
                    type="email"
                    [(ngModel)]="email"
                  />
                </div>
                <div class="v-text-field__details">
                  <!-- エラー時 class="v-messages ..." に error--text を追加 ↓ -->
                  <div class="v-messages theme--light error--text">
                    <div
                      *ngIf="errorMessages.forgetpassword.email"
                      class="v-messages__wrapper"
                    >
                      {{ errorMessages.forgetpassword.email }}

                      <!-- 注釈及びエラーテキストが入ります。 -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="text-center mb-6">
              <button
                type="button"
                class="v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default primary primary-button"
                medium=""
                (click)="changePassword()"
              >
                <span class="v-btn__content bold"> 再設定リンクを送信 </span>
              </button>
            </div>
            
            <div *ngIf="!withoutLoginLink" style="justify-content: center; display: flex">
              <a (click)="navigate('login')" class="text-link v-text-caption">
                ログイン
              </a>
            </div>
          </form>
        </div>
      </main>
    </div>
  </div>
  <!-- 送信しましたページ -->
  <div *ngIf="page === 'password-reset-send'">
    <app-collabo-portal-change-password-sent></app-collabo-portal-change-password-sent>
  </div>
  <app-collabo-portal-register-resend
    *ngIf="page === 'register-resend'"
  ></app-collabo-portal-register-resend>
</ng-container>
